import React, { useContext } from "react";

import AddBoxIcon from "@mui/icons-material/AddBox";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { isAuthorizedEndpoint, toolGroupsDropdownEndpoint, toolsEndpoint } from "../../Services/apiEndpoint";
import { errorManagement } from "../../Services/errorManagement";
import { HomeAppContext } from "../Home";
import api from "../../Services/api";
import MyTable from "../General/Pagination/MyTable";
import Entry from "./Entry";
import Create from "./Create";
import Edit from "./Edit";
import ConfirmDialog from "../General/ConfirmDialog";

export default function List(props) {
  const { homeState, homeDispatch } = useContext(HomeAppContext);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openCreate, setOpenCreate] = React.useState(false);
  const [currentEntry, setCurrentEntry] = React.useState(null);
  const [refresh, setRefresh] = React.useState(0);
  const [deleteParams, setDeleteParams] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);

  const isAdmin = homeState.userProfile.role === "Admin";

  const tableOptions = {
    columns: [
      {
        name: "ToolGroup",
        description: "Tool Group",
        sortable: true,
        filter: {
          enabled: false,
        },
        size: !isAdmin ? 4 : 3,
      },
      {
        name: "Name",
        description: "Name",
        sortable: true,
        filter: {
          enabled: false,
        },
        size: !isAdmin ? 4 : 3,
      },
      {
        name: "Description",
        description: "Description",
        sortable: true,
        filter: {
          enabled: false,
        },
        size: 4
      }
    ],
    defaultSort: [
      { name: "ToolGroup", order: "" },
      { name: "Name", order: "" }
    ],
    additionalFilters: [
      {
        name: "GroupId",
        description: "Tool Group",
        filter: {
          enabled: true,
          required: false,
          comparison: "==",
          type: "autocomplete",
          options: {
            url: toolGroupsDropdownEndpoint,
            liveOptions: false,
          },
        },
        size: 3,
      },
      {
        name: "Name",
        description: "Name",
        filter: {
          enabled: true,
          comparison: "@=*",
          type: "text",
          value: "",
          defaultIndex: 0,
          placeholder: "Name",
        },
        size: 3,
      }
    ]
  };

  React.useEffect(() => {
    api
      .get(isAuthorizedEndpoint)
      .then((r) => {
        homeDispatch({
          type: "UPDATE_CURRENT_LOCATION",
          data: "Tools",
        });
      })
      .catch((error) => errorManagement.formErrors(error, homeDispatch));
  }, [homeDispatch]);


  const handleClickCreate = (event) => {
    setOpenCreate(true);
  };

  const handleClickEdit = (event, entry) => {
    setCurrentEntry(entry);
    setOpenEdit(true);
  };

  const handleClickConfirmDelete = (event, entry) => {
    setDeleteParams({ id: entry.id });
    setOpenDelete(true);
  };
  const acceptDelete = (params) => {
    homeDispatch({
      type: "NOTIFICATION",
      data: { message: "Deleting", loading: true },
    });
    api.delete(`${toolsEndpoint}/${params.id}`).then((response) => {
      homeDispatch({
        type: "NOTIFICATION",
        data: { message: "Tool Deleted", type: "success" },
      });
      refreshItems();
    }).catch((error) => {
      errorManagement.formErrors(error, homeDispatch);
    });
  };
  const cancelDelete = () => {
    setDeleteParams(null);
  };

  const refreshItems = () => {
    setRefresh(refresh + 1);
  };

  return (
    <React.Fragment>
      <Grid container spacing={2} justifyContent={"space-between"}>
        {isAdmin && (
          <Grid item xs={12}>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleClickCreate}
              startIcon={<AddBoxIcon />}
            >
              New Tool
            </Button>
          </Grid>
        )}
        <Grid item xs={12}>
          <MyTable
            options={tableOptions}
            url={`${toolsEndpoint}/list`}
            refresh={refresh}
            label={"Tools"}
            renderItem={(item, index) => (
              <Entry
                key={index}
                entry={item}
                allowActions={isAdmin}
                onEdit={handleClickEdit}
                onDelete={handleClickConfirmDelete}
              />
            )}
          />
        </Grid>
      </Grid>
      {isAdmin && (
        <React.Fragment>
          <Edit
            open={openEdit}
            setOpen={setOpenEdit}
            entry={currentEntry}
            onEdit={refreshItems}
          />
          <Create
            open={openCreate}
            setOpen={setOpenCreate}
            onCreate={refreshItems}
          />
          <ConfirmDialog
            open={openDelete}
            setOpen={setOpenDelete}
            title={"Delete Tool"}
            message={"Are you sure that you want to delete this Tool?"}
            onCloseSuccess={acceptDelete}
            successParams={deleteParams}
            onClose={cancelDelete}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
